module.exports = __webpack_public_path__ + "static/media/st.0d633624.svg";